document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-av-search] .avs-sort select').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
  document.querySelectorAll('[data-av-collection] .avc-filters').forEach(form => {
    form.addEventListener('change', event => {
      if (event.target.matches('select, input[type="checkbox"], input[type="number"]')) {
        form.requestSubmit();
      }
    });
  });
});
